import { render, staticRenderFns } from "./SortSetting.vue?vue&type=template&id=83463844&scoped=true&"
import script from "./SortSetting.vue?vue&type=script&lang=js&"
export * from "./SortSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83463844",
  null
  
)

export default component.exports